module.exports = __webpack_public_path__ + "media/images/championship__iconPickTeam--plain-b598390e45764ecee3f4124e6b80a06f.png";